import React from 'react';
import PropTypes from 'prop-types';
import {Dot} from "../dot/Dot";
import styles from './FeatureItem.module.scss';

export const FeatureItem = (props) => {
  const {label} = props;

  return (
    <Dot>
      <p className={styles.label}>{label}</p>
    </Dot>
  );
};

FeatureItem.propTypes = {
  label: PropTypes.string
}

FeatureItem.defaultProps = {}

export default React.memo(FeatureItem);